"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitContactInfoStarted = exports.contactInfosError = exports.receiveContactInfos = exports.receiveContactInfosStarted = exports.SUBMIT_CONTACT_INFOS_STARTED = exports.CONTACT_INFOS_ERROR = exports.RECEIVE_CONTACT_INFOS = exports.RECEIVE_CONTACT_INFOS_STARTED = void 0;
exports.default = reducer;
exports.loadContactInfos = loadContactInfos;
exports.submitContactForm = submitContactForm;
exports.submitContactFormIfMissingId = submitContactFormIfMissingId;
const api_1 = require("core/api");
const api_utils_1 = require("core/api-utils");
const lodash_1 = require("lodash");
const redux_form_1 = require("redux-form");
// ducks
const app_1 = require("./app");
const app_2 = require("selectors/app");
// selectors
const contact_infos_1 = require("selectors/contact-infos");
const profile_1 = require("selectors/profile");
const user_1 = require("selectors/user");
// Actions
exports.RECEIVE_CONTACT_INFOS_STARTED = 'RECEIVE_CONTACT_INFOS_STARTED';
exports.RECEIVE_CONTACT_INFOS = 'RECEIVE_CONTACT_INFOS';
exports.CONTACT_INFOS_ERROR = 'CONTACT_INFOS_ERROR';
exports.SUBMIT_CONTACT_INFOS_STARTED = 'SUBMIT_CONTACT_INFOS_STARTED';
// Reducer
const initialState = {
    contactInfos: [],
    contactInfosLoaded: false,
};
function reducer(state = initialState, action) {
    switch (action.type) {
        case 'RECEIVE_CONTACT_INFOS_STARTED':
            return {
                ...state,
            };
        case 'RECEIVE_CONTACT_INFOS':
            return {
                ...state,
                contactInfos: (0, lodash_1.uniqBy)(state.contactInfos.concat(action.data), 'id'),
                contactInfosLoaded: true,
            };
        case 'CONTACT_INFOS_ERROR':
            return {
                ...state,
                contactInfosLoaded: false,
                error: action.error,
            };
        default:
            return state;
    }
}
// Action Creators
const receiveContactInfosStarted = () => {
    return { type: exports.RECEIVE_CONTACT_INFOS_STARTED };
};
exports.receiveContactInfosStarted = receiveContactInfosStarted;
const receiveContactInfos = (data) => {
    return { type: exports.RECEIVE_CONTACT_INFOS, data };
};
exports.receiveContactInfos = receiveContactInfos;
const contactInfosError = (data) => {
    return { type: exports.CONTACT_INFOS_ERROR, data };
};
exports.contactInfosError = contactInfosError;
const submitContactInfoStarted = () => {
    return { type: exports.SUBMIT_CONTACT_INFOS_STARTED };
};
exports.submitContactInfoStarted = submitContactInfoStarted;
// services
function loadContactInfos(personId) {
    return (dispatch) => {
        dispatch((0, exports.receiveContactInfosStarted)());
        return api_1.ContactsService.getContactInfos(personId)
            .then((data) => {
            const updatedContactInfos = updateAllContactInfos(data);
            return dispatch((0, exports.receiveContactInfos)(updatedContactInfos));
        })
            .catch((error) => {
            return dispatch((0, exports.contactInfosError)(error));
        });
    };
}
function updateContactInfo(objectToUpdate, contact) {
    const index = (0, lodash_1.findIndex)(objectToUpdate, ['id', contact.id]);
    if (index === -1) {
        objectToUpdate.push(contact);
    }
    else {
        objectToUpdate[index] = contact;
    }
    return objectToUpdate;
}
function updateAllContactInfos(contacts) {
    const list = [];
    contacts.map((contact) => {
        updateContactInfo(contact);
    });
    function updateContactInfo(contact) {
        const index = (0, lodash_1.findIndex)(list, ['id', contact.id]);
        if (index === -1) {
            list.push(contact);
        }
        else {
            list[index] = contact;
        }
        return contact;
    }
    return list;
}
function submitContactForm(personId, contactInfoFormData, forceSubmit = false, hideFeedback = false) {
    // let successText = "Contact information has been updated";
    // let errorText = "Failed to update contact information";
    const successText = 'Profile information has been updated';
    const errorText = 'Failed to update profile information';
    const data = contactInfoFormData;
    return (dispatch, getState) => {
        dispatch((0, exports.submitContactInfoStarted)());
        // tell the API to use the single address street and repeater fields
        const isUCIenabled = (0, user_1.getIsUCIenabled)(getState());
        if (!isUCIenabled) {
            delete data.emailAddresses;
            delete data.phoneNumbers;
        }
        if (data.id) {
            return api_1.ContactsService.updateContactInfo(personId, data, isUCIenabled)
                .then((data) => {
                const formatContactInfoResponse = updateContactInfo((0, contact_infos_1.getContactInfos)(getState()), data);
                dispatch((0, exports.receiveContactInfos)(formatContactInfoResponse));
                if (!hideFeedback) {
                    dispatch((0, app_1.appFeedbackMessageSuccess)(successText));
                }
                return data;
            })
                .catch((errorRes) => {
                if (!hideFeedback) {
                    dispatch((0, app_1.appFeedbackMessageError)(errorText));
                }
                if ((0, app_2.showSaveNeeded)(getState())) {
                    const rejectedPromise = new Promise((_resolve, reject) => {
                        // eslint-disable-line no-unused-vars
                        setTimeout(() => {
                            reject('contact form reject Save Needed');
                        }, 1000);
                    });
                    return rejectedPromise;
                }
                if (errorRes.validationErrors) {
                    throw new redux_form_1.SubmissionError({
                        contactInfos: (0, api_utils_1.formatApiErrors)(errorRes.validationErrors),
                    });
                }
                else {
                    return Promise.reject(errorText);
                }
            });
            // put something else in the else to cover form.hasChanged()
        }
        else if (forceSubmit) {
            return api_1.ContactsService.createContactInfo(personId, data, isUCIenabled)
                .then((data) => {
                dispatch((0, exports.receiveContactInfos)(data));
                return dispatch((0, app_1.appFeedbackMessageSuccess)(successText));
            })
                .catch((errorRes) => {
                dispatch((0, app_1.appFeedbackMessageError)(errorText));
                if ((0, app_2.showSaveNeeded)(getState())) {
                    const rejectedPromise = new Promise((_resolve, reject) => {
                        // eslint-disable-line no-unused-vars
                        setTimeout(() => {
                            reject('contact form reject Save Needed');
                        }, 1000);
                    });
                    return rejectedPromise;
                }
                if (errorRes.validationErrors) {
                    throw new redux_form_1.SubmissionError({
                        contactInfos: (0, api_utils_1.formatApiErrors)(errorRes.validationErrors),
                    });
                }
            });
        }
        else {
            return null;
        }
    };
}
// If they have a UUID and no contact info, we are going to create one automatically
// submitContactForm will call receiveContacts on the return data to update the store
function submitContactFormIfMissingId(contactInfoValues) {
    return (dispatch, getState) => {
        const hasPerson = (0, profile_1.profileHasPerson)(getState());
        const personId = (0, profile_1.getPersonId)(getState());
        if (hasPerson && (0, contact_infos_1.findPrimaryByPerson)((0, contact_infos_1.getContactInfos)(getState()), personId)) {
            return dispatch(submitContactForm(personId, contactInfoValues, true, true));
        }
    };
}
